import React from "react";
import {
  MotifBreadcrumb,
  MotifBreadcrumbItem,
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import { Link, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { updateShowDiscardModalState } from "../../store/slices/CheckoutSlice";
import { useAppDispatch } from "../../store/hooks";
type BreadcrumbItem = {
  text: string;
  url?: string;
  icon?: JSX.Element;
  variant?: "default" | "alt";
  disabled?: boolean;
  blockNavigation?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  ariaLabel?: string;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, ariaLabel }) => {
  const nav = useNavigate();
  const isEstimateChanged = useSelector(
    (state: RootState) => state.CheckoutSlice.isEstimateChanged,
  ) || false;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (item: BreadcrumbItem) => {
    if (item?.url && !item?.blockNavigation) {
      if (isEstimateChanged) {
        sessionStorage.setItem('redirectTo', item?.url || "");
        dispatch(updateShowDiscardModalState(true));
      }
      if (!isEstimateChanged) {
        dispatch(updateShowDiscardModalState(false));
        navigate(item?.url || "");
      }
    }
  };
  function handleBackFuction() {
    let item: any = undefined;
    if (items.length > 1) {
      item = items[items.length - 2];
    } else {
      item = items[0];
    }
    if (!item?.blockNavigation && item?.url) {
      if (isEstimateChanged) {
        sessionStorage.setItem('redirectTo', item?.url);
        dispatch(updateShowDiscardModalState(true));
      } else {
        dispatch(updateShowDiscardModalState(false));
        nav(item?.url);
      }
    }
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {items?.length >= 3 && (
        <div
          onClick={() => handleBackFuction()}
          style={{ position: "relative", top: "3px", cursor: "pointer" }}
        >
          <MotifIcon src={IconoirArrowLeft} />
        </div>
      )}
      <div>
        <MotifBreadcrumb aria-label={ariaLabel}>
          {items.map((item, index) => (
            <MotifBreadcrumbItem
              key={index}
              variant={item.variant || "default"}
              disabled={item.disabled}
            >
              {item.url ? (
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(item);
                  }}
                  to={item?.url ? item.url : ""}
                  className="display-flex align-items-center breadcrumb-link"
                >
                  {item.icon && index === 0 && items?.length < 3 && (
                    <span>{item.icon}</span>
                  )}
                  <span
                    className={`${item.icon && index === 0 ? "pad-l-10" : "margin-left-0"
                      }`}
                  >
                    {item.text}
                  </span>
                </Link>
              ) : (
                <div className="display-flex align-items-center">
                  {item.icon && <span>{item.icon}</span>}
                  <span
                    className={`pad-l-10 ${item.icon ? "" : "margin-left-0"}`}
                  >
                    {item.text}
                  </span>
                </div>
              )}
            </MotifBreadcrumbItem>
          ))}
        </MotifBreadcrumb>
      </div>
    </div>
  );
};

export default Breadcrumb;
